export const ACTIVITY_TYPE = {
    TYPE_FLEXTIME_ACCEPTED: 'flextime_accepted',
    TYPE_FLEXTIME_DECLINED: 'flextime_declined',
    TYPE_FLEXTIME_DELETED: 'flextime_deleted',
    TYPE_FLEXTIME_UPDATED: 'flextime_updated',
    TYPE_FLEXTIME_BALANCE_UPDATED: 'flextime_balance_updated',
    TYPE_CALENDAR_DELETED: 'calendar_deleted',
    TYPE_CALENDAR_CREATED: 'calendar_created',
    TYPE_CALENDAR_APPROVED: 'calendar_approved',
    TYPE_CALENDAR_DECLINED: 'calendar_declined',
    TYPE_CALENDAR_UPDATED: 'calendar_updated'
}

export const CALENDAR_ACTIVITY_TYPES = [
    ACTIVITY_TYPE.TYPE_CALENDAR_DELETED,
    ACTIVITY_TYPE.TYPE_CALENDAR_CREATED,
    ACTIVITY_TYPE.TYPE_CALENDAR_APPROVED,
    ACTIVITY_TYPE.TYPE_CALENDAR_DECLINED,
    ACTIVITY_TYPE.TYPE_CALENDAR_UPDATED
]

export default {
    ACTIVITY_TYPE
}